// TODO: TEMP PATCH REMOVE AFTER APOLLO CLIENT
export const SET_FAN_GENRES = 'SET_FAN_GENRES';
